export const FrameEventTypes = {
  ADD_FRAME_REQUESTED: "ADD_FRAME_REQUESTED",
  FRAME_ADDED: "FRAME_ADDED",

  REMOVE_FRAME_REQUESTED: "REMOVE_FRAME_REQUESTED",
  FRAME_REMOVED: "FRAME_REMOVED",
};
